import { BankAccountModel } from 'api-hooks/bank-account';
import * as Yup from 'yup';

export const BankAccountFormSchema = () =>
  Yup.object({
    code: Yup.string().default('').required(),
    name: Yup.string().default('').required(),
    accountNumber: Yup.string().default('').required(),
    description: Yup.string().default(''),
    balance: Yup.number().default(0),
  });

export type BankAccountFormType = {
  code: string;
  name: string;
  accountNumber: string;
  description: string;
  balance: number;
  bankAccount?: BankAccountModel;
};
